export default "/images/0a31af6fe3b4a88c76e45116da6bc021.avif";